<template>
  <div class="row">
    <div :class="listStyle" v-if="!this.$props.addClt">
      <List
        :__list="dataArray"
        :__isOnLoad="isListOnload"
        :__userList="this.userList"
        v-on="{allowUpdateRq: onAllowUpdateRq}"
      ></List>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import List from './List';
export default {
  components: {
    List,
  },
  props: {
    addClt:  {
      type: Boolean,
      default: () => {
        return false;
      },
    },

    onSelect: {
        type: Function,
        default: () => {()=>{}},
      },
  },

  data() {
    return {
      moduleRoute: '/dddevis',
      onEditionId: null,
      onEditionIdx: -1,
      onEditionItem: null,
      onEditionCopie: null,
      isListOnload: false,
      isEditOnload: false,
      editionMode: false,
      dataArray: [],
      onGoingReq:[],
      userList:[],
      intervalID: null,
      admin: null,
    };
  },

  computed: {
    listStyle() {
      return this.onEditionId !== null ? 'col-md-6' : 'col-md-12';
    },

    editStyle() {
      return this.$props.addClt !== true ? 'col-md-6' : 'col-md-12';
    },
  },

  methods: {
    resolveExercice() {
      const fromCookie = Vue.$cookies.get("exercice");
      const archive = String(fromCookie || new Date().getFullYear());

      if (!fromCookie) {
        Vue.$cookies.set("exercice", archive);
      }

      return archive;
    },

    handleArchiveChange() {
      this.loadData();
    },

    onAllowUpdateRq(state) {
      this.editionMode = state !== null
    },

    cancelAction() {
      this.onEditionId = null;
      this.onEditionIdx = -1;
      this.onEditionItem = null;
    },

    copieAction() {
      if(this.$props.addClt) {
        this.onEditionCopie = { ...this.onEditionItem }
        this.addAction()
      }
    },

    saveAction() {
      this.onGoingReq.push({});
      let $onNext = (response) => {
        if(this.$props.addClt &&  this.onEditionCopie !== null) {
          Vue.$cookies.set('user',{
            type: 'GUEST',
            ID: this.onEditionCopie._id,
            societe: this.onEditionCopie.name,
            name: this.onEditionCopie.name
          });
          this.$router.push('/')
        }
        else {
          this.loadData(this.onEditionId, null, this.onEditionIdx);
        }

      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      // let diff = this.__.differ(
      //   this.dataArray[this.onEditionIdx],
      //   this.onEditionItem
      // );
      // diff.push('_id');
      
      let data = this.onEditionItem;//this._.pick(this.onEditionItem, diff);
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    setUpdateAll(itm) {
      const findIdx = (element) => element._id == itm._id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onEditionIdx = idx;
      this.onEditionItem = itm;
      this.saveAction()
    },

    setUpdateValue(id, val, flag) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.dataArray[idx][flag] = val;
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id', flag]);
      data[flag] = val;
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    deleteAction(id) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        if (response.data == 'OK') {
          this.dataArray.splice(idx, 1);
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id']);
      this.__.httpAction({
        methode: 'DELETE',
        route: this.moduleRoute+"/"+data._id,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    editAction(id) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx)
      this.onEditionId = id;
      this.onEditionIdx = idx;
      this.onEditionItem = this._.omit(this.dataArray[idx]);
      if(this.$props.addClt && this.onEditionCopie !== null) {

        this.onEditionItem =  this.onEditionCopie;
        this.onEditionIdx = 0
        this.onEditionId = this.onEditionItem._id = this.dataArray[this.onEditionIdx]._id
        this.saveAction()
      }
    },

    updateAction(conf) {
      this.__.httpAction({
        methode: 'POST',
        route: this.moduleRoute,
        data: conf.data,
        onNext: conf.$onNext,
        onError: conf.$onError,
        onComplete: conf.$onComplete,
      });
    },

    addAction() {
      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.loadData(response.data, () =>
          this.editAction(response.data)
        );
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };
      this.__.httpAction({
        methode: 'PUT',
        route: this.moduleRoute,
        data: {exercice: this.resolveExercice()},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    loadData(id = null, cb = null, putAt = null) {
      let $onNext = (response) => {
        if (id != null) {
          if (putAt != null) {
            if(putAt === -1) {
              const idx = (element) => element._id === id;
              var position = this.dataArray.findIndex(idx)
              this.dataArray[position] = response.data[0];
            } else {
              this.dataArray[putAt] = response.data[0];
            }

          } else {
            this.dataArray.unshift(response.data[0]);
          }

          if (cb) cb();
        } else {
          this.dataArray = response.data;
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      const exercice = this.resolveExercice();
      var path = this.moduleRoute+'/'+exercice;
      
      if(id === null) {
        if(this.admin.type === 'CLIENT') {
          path = path+'/byclient/'+this.admin.pid
        }
        if(this.admin.type === 'COMMERCIAL') {
          path = path+'/bycomm/'+this.admin._id
        }
      }
      this.onGoingReq.push({});
      this.__.httpAction({
        methode: 'GET',
        route: path+ (id != null ? '/'+id : '/'),
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    loadUsers() {
     let $onNext = (response) => {
      this.userList= response.data
      .filter(e => ((e.type === 'COMMERCIAL' || e.type === 'ADMIN') && (e.isActive === true || e.isActive === 1)))
      .map(e => {

         return {
           id: e._id,
           name: e.name,
         }
       })
     };

     const $onError = () => {};
     const $onComplete = () => {
       if (this.onGoingReq.length > 0) this.onGoingReq.pop();
     };

     this.onGoingReq.push({});
     this.__.httpAction({
       methode: 'GET',
       route: '/admins',
       data: {},
       onNext: $onNext,
       onError: $onError,
       onComplete: $onComplete,
     });
   },

  },
  mounted() {
    //this.patch();
    if(this.$props.addClt) {
    //  this.loadData('678060f59881fc1c3078bbfd',() => {
    //   this.editAction('678060f59881fc1c3078bbfd')
    //  })
    } else {
      this.admin = Vue.$cookies.get("user");
      this.$root.$on("archive:changed", this.handleArchiveChange);
      this.loadData();
      this.loadUsers();
      
      if(this.intervalID === null) {
        this.intervalID = setInterval(()=> {
          if(this.editionMode === false)
            this.loadData();}
          , 10000)
      }
    }

  },

  watch: {
    onGoingReq: function () {
      this.isListOnload = this.isEditOnload = this.onGoingReq.length > 0;
    },
  },

  beforeDestroy() {
    this.$root.$off("archive:changed", this.handleArchiveChange);
  },
};
</script>
<style></style>
